var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('app-navigation'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('app-cookies-consent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }